import { currencyFormatter } from '@/shared/utils/currency';
import { FormatByType } from './types';

export const formatByType: FormatByType = {
  number: (value: number) => currencyFormatter.format(value),
  percentage: (value: number) => value.toFixed(2) + '%',
  x: (value: number) => `${value.toFixed(2)}X`,
  yesNo: (value: boolean) => (value ? 'YES' : 'NO'),
  string: (value: string) => value,
  date: (value: string) => value,
  JSX: (value: JSX.Element) => value
};
